import Http from "../service/api";

// -----------------------------  考试信息  -------------------------
/**
 * 外部用户获取考试集合 get query
 * @param {*} params 
 */
export async function getExternalExamList(params: any) {
  return Http.get(`/public/v1/exam/external/list`, params);
}
/**
 * 外部用户获取某个考试详情 get query
 * @param {*} params 
 */
export async function getExternalInfoList(params: any) {
  return Http.get(`/public/v1/exam/external/info`, params);
}
/**
 * 外部用户报名考试 post formData
 * @param {*} params 
 */
export async function signExamExternal(params: any) {
  return Http.post(`/public/v1/exam/external/sign`, params, 'formData');
}
/**
 * 外部用户查询证书 get query
 * @param {*} params 
 */
export async function getCertList(params: any) {
  return Http.get(`/public/v1/cert/list`, params);
}
/**
 * 活动集合外部用户 get query
 * @param {*} params 
 */
export async function getExternalActist(params: any) {
  return Http.get(`/public/v1/campaign/ex/list`, params);
}
/**
 * 活动详情（外部用户） get query
 * @param {*} params 
 */
export async function getExActInfo(params: any) {
  return Http.get(`/public/v1/campaign/ex/info`, params);
}
// -----------------------------  首页  -------------------------
/**
 * 对外首页查询课程集合 get query
 * @param {*} params 
 */
export async function getCourseList(params: any) {
  return Http.get(`/public/v1/index/curriculumlist`, params);
}
/**
 * 公共首页查询轮播图集合 get query
 * @param {*} params 
 */
export async function getBannerList(params: any) {
  return Http.get(`/public/v1/slideshow/list`, params);
}
// -----------------------------  全象  -------------------------
/**
 * 获取权限SSO地址（简单说就是获取全象的登陆页面） get query
 * @param {*} params 
 */
export async function getQxSso(params: any) {
  return Http.get(`/v1/qx/sso`, params);
}
/**
 * SSO登陆全象 post query
 * @param {*} params 
 */
export async function getQxToken(params: any) {
  return Http.post(`/v1/qx/login`, params);
}
/**
 * token post query
 * @param {*} params 
 */
 export async function getQxProfile(params: any) {
  return Http.post(`/v1/qx/getProfile`, params);
}
